import styled from 'styled-components';
import { Tag } from 'antd';
import CustomTable from '../CustomTable';
import TextBox from 'components/TextBox';
import { IToken } from 'store/ducks/globalTypes';

export const StyledCustomTable = styled(CustomTable)<IToken>`
  .ant-table-row-expand-icon-cell {
    display: none;
  }

  .ant-table-wrapper {
    .ant-table {
      margin: unset !important;
    }
  }

  .ant-spin-nested-loading {
    overflow-y: initial !important;
  }

  .ant-table-thead tr:first-child .ant-table-cell[colspan='2']::after {
    height: 1.5em;
    top: 100% !important;
    z-index: 10;
  }

  .ant-table-thead th {
    padding: 5px 16px !important;
  }

  .ant-table-thead th[colspan='2'] {
    padding-left: 0px !important;
  }
`;

export const StyledTag = styled(Tag)`
  width: 100px;
  padding: 0 9px;
  font-size: 14px;
  text-align: center;
`;

export const StyledTextBox = styled(TextBox)`
  height: 0;
  padding: unset !important;
`;
